import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    clientSecret: String,
    publishableKey: String,
    stripeAccount: String
  }

  async connect() {
    const stripe = Stripe(this.publishableKeyValue, { stripeAccount: this.stripeAccountValue })
    const checkout = await stripe.createEmbeddedCheckoutPage({
      fetchClientSecret: () => Promise.resolve(this.clientSecretValue)
    })

    if (!this.element.isConnected) return checkout.destroy()

    this.checkout = checkout
    checkout.mount(this.element)
  }

  disconnect() {
    this.checkout?.destroy()
    this.checkout = null
  }
}
